/**
 * A question the page asks in its confirm dialog before an action that leaves something (ADR-061's amendment
 * "character select as redesigned"): the dialog's title, its one sentence, the confirm button's words, and its
 * tone, `danger` for an action that ends the session and `primary` for one that ends nothing.
 */
export interface Question {
  readonly title: string;
  readonly body: string;
  readonly confirm: string;
  readonly tone: "danger" | "primary";
  readonly width: number;
}

/**
 * Asks a question in the page's confirm dialog.
 *
 * @param question What to ask.
 * @returns True once the player confirmed and the dialog has closed; false when they cancelled, or when a dialog
 *   was already open.
 */
export type Ask = (question: Question) => Promise<boolean>;

/**
 * An `Ask` that confirms at once, for a page or a test that shows no dialog.
 *
 * @returns True.
 */
export const ASK_NOTHING: Ask = () => Promise.resolve(true);
